var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/configurations/karakter": "2464",
	"./assets/configurations/karakter.json": "2464",
	"./assets/configurations/kiesreis": "413f",
	"./assets/configurations/kiesreis.json": "413f",
	"./assets/images/backgrounds/parralax-bg-1.png": "da8a",
	"./assets/images/backgrounds/parralax-bg-2.png": "52d6",
	"./assets/images/backgrounds/triangle_background.png": "e17a",
	"./assets/images/cardSwiping/acceptButtonImage.png": "78ea",
	"./assets/images/cardSwiping/declineButtonImage.png": "41db",
	"./assets/images/cardSwiping/testImages/books.jpg": "7e2a",
	"./assets/images/cardSwiping/testImages/dog.jpg": "ddd5",
	"./assets/images/cardSwiping/testImages/programming.png": "6b5f",
	"./assets/images/companyLogos/facebook_logo.png": "391c",
	"./assets/images/companyLogos/google_logo.png": "847d",
	"./assets/images/home/account-image.png": "db23",
	"./assets/images/home/duration-image.png": "75ac",
	"./assets/images/home/identitiet-image.png": "6d69",
	"./assets/images/logos/kiesreis_logo.png": "6694",
	"./assets/images/logos/kiesreis_logo_background.png": "cd58",
	"./assets/images/logos/kieswijs_logo.png": "e3e2",
	"./assets/images/logos/kieswijs_logo_background.png": "a53f",
	"./assets/images/pointer-arrow-left.png": "f722",
	"./assets/images/privacy-policy/kieswijsanalyse_logo.png": "5b57",
	"./assets/images/waarden/NextIcon.png": "40e6",
	"./assets/images/waarden/QuestionMarkIcon.png": "f9bf",
	"./assets/images/waarden/SelectIcon.png": "aaf6",
	"./assets/images/waarden/inspect_card_icon.png": "6a8a",
	"./assets/images/waarden/next_round_icon.png": "c63b",
	"./assets/styles/global.sass": "134f",
	"./assets/styles/modules/_breakpoints.sass": "f0b1",
	"./assets/styles/modules/_colors.sass": "8df0",
	"./assets/styles/modules/_flex.sass": "f065",
	"./assets/styles/modules/_margins.sass": "eeab",
	"./assets/styles/modules/_paddings.sass": "782b",
	"./assets/styles/modules/_shadow.sass": "6326",
	"./assets/styles/partials/_buttons.sass": "1e74",
	"./assets/styles/partials/_cards.sass": "9711",
	"./assets/styles/partials/_containers.sass": "86de",
	"./assets/styles/partials/_forms.sass": "79dd",
	"./assets/styles/partials/_utilities.sass": "eccf",
	"./assets/styles/vendor/_fonts.sass": "d48f",
	"./components/AppFooter": "f657",
	"./components/AppFooter.vue": "f657",
	"./components/BackgroundTriangle": "0b0a",
	"./components/BackgroundTriangle.vue": "0b0a",
	"./components/NavigationBar": "641e",
	"./components/NavigationBar.vue": "641e",
	"./components/ScrollDownHint": "42f3",
	"./components/ScrollDownHint.vue": "42f3",
	"./components/chart/Chart": "aa6c",
	"./components/chart/Chart.vue": "aa6c",
	"./components/chart/ChartRow": "c27d",
	"./components/chart/ChartRow.vue": "c27d",
	"./components/home/HomeHero": "e23e",
	"./components/home/HomeHero.vue": "e23e",
	"./components/home/TestItemContainer": "659a",
	"./components/home/TestItemContainer.vue": "659a",
	"./components/home/TestsBody": "0c02",
	"./components/home/TestsBody.vue": "0c02",
	"./components/results/identiteit/IdentiteitCardsResults": "5d0b",
	"./components/results/identiteit/IdentiteitCardsResults.vue": "5d0b",
	"./components/results/identiteit/IdentiteitResultsBody": "95f5",
	"./components/results/identiteit/IdentiteitResultsBody.vue": "95f5",
	"./components/results/identiteit/IdentiteitResultsHeader": "8952",
	"./components/results/identiteit/IdentiteitResultsHeader.vue": "8952",
	"./components/results/riasoc/RiasocResultsBody": "0ab3",
	"./components/results/riasoc/RiasocResultsBody.vue": "0ab3",
	"./components/results/riasoc/RiasocResultsHeader": "1a08",
	"./components/results/riasoc/RiasocResultsHeader.vue": "1a08",
	"./components/results/unknown/UnknownResultsBody": "11be",
	"./components/results/unknown/UnknownResultsBody.vue": "11be",
	"./components/results/unknown/UnknownResultsHeader": "c5d4",
	"./components/results/unknown/UnknownResultsHeader.vue": "c5d4",
	"./components/results/waardenspel/WaardenResultsBody": "f552",
	"./components/results/waardenspel/WaardenResultsBody.vue": "f552",
	"./components/results/waardenspel/WaardenResultsHeader": "41f4",
	"./components/results/waardenspel/WaardenResultsHeader.vue": "41f4",
	"./components/tests/swipeableCards/ActionButton": "81b2",
	"./components/tests/swipeableCards/ActionButton.vue": "81b2",
	"./components/tests/swipeableCards/CardsStackGame": "30f9",
	"./components/tests/swipeableCards/CardsStackGame.vue": "30f9",
	"./components/tests/swipeableCards/ExplanationCard": "f14d",
	"./components/tests/swipeableCards/ExplanationCard.vue": "f14d",
	"./components/tests/swipeableCards/GameCard": "aa62",
	"./components/tests/swipeableCards/GameCard.vue": "aa62",
	"./components/tests/swipeableCards/GameCardStack": "e586",
	"./components/tests/swipeableCards/GameCardStack.vue": "e586",
	"./components/tests/swipeableCards/RotatingGameCard": "a3c0",
	"./components/tests/swipeableCards/RotatingGameCard.vue": "a3c0",
	"./components/tests/swipeableCards/SwipingExplanationView": "0cdf",
	"./components/tests/swipeableCards/SwipingExplanationView.vue": "0cdf",
	"./components/tests/swipeableCards/rotatableCardComponents/RotatableCardFace": "9b7d",
	"./components/tests/swipeableCards/rotatableCardComponents/RotatableCardFace.vue": "9b7d",
	"./components/tests/waarden/WaardenCard": "ace0",
	"./components/tests/waarden/WaardenCard.vue": "ace0",
	"./components/tests/waarden/WaardenCardsView": "e086",
	"./components/tests/waarden/WaardenCardsView.vue": "e086",
	"./components/tests/waarden/WaardenExplanation": "251b",
	"./components/tests/waarden/WaardenExplanation.vue": "251b",
	"./components/tests/waarden/WaardenGame": "d217",
	"./components/tests/waarden/WaardenGame.vue": "d217",
	"./components/tests/waarden/WaardenRoundIndicator": "75ba",
	"./components/tests/waarden/WaardenRoundIndicator.vue": "75ba",
	"./constants": "5fb0",
	"./constants.js": "5fb0",
	"./main": "56d7",
	"./main.js": "56d7",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./store/modules/identiteitResults": "0888",
	"./store/modules/identiteitResults.js": "0888",
	"./store/modules/riasocResults": "1b08",
	"./store/modules/riasocResults.js": "1b08",
	"./store/modules/testData": "182a",
	"./store/modules/testData.js": "182a",
	"./store/modules/user": "0f9a",
	"./store/modules/user.js": "0f9a",
	"./store/modules/waardenResults": "1bcb",
	"./store/modules/waardenResults.js": "1bcb",
	"./views/Account": "77be",
	"./views/Account.vue": "77be",
	"./views/AnswerOverview": "148c",
	"./views/AnswerOverview.vue": "148c",
	"./views/ErrorPage": "c63e",
	"./views/ErrorPage.vue": "c63e",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/PrivacyPolicy": "729e",
	"./views/PrivacyPolicy.vue": "729e",
	"./views/Results": "b3c3",
	"./views/Results.vue": "b3c3",
	"./views/TestEnvironment": "279a",
	"./views/TestEnvironment.vue": "279a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";